import * as actions from "../actions/workflows";

const INITIAL_STATE = {
  error: null,
  workflows: [],
  workflow: null,
  nodes: [],
  node: null,
  functions: [],
  funct: null,
  saving: false,
  savingWorkflow: false,
  savingNode: false,
  savingFunction: false,
  runningNode: false,
  runningWorkflow: false,
  nodeResults: false,
  workflowResults: false,
  functionToAdd: null,
  trainingWorkflows: null,
  inferenceWorkflows: null,
  supportingContentWorkflows: null,
};

const workflows = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.RETRIEVED_WORKFLOWS:
      return {
        ...state,
        workflows: action.workflows,
      };
    case actions.RETRIEVED_TRAINING_WORKFLOWS:
      return {
        ...state,
        trainingWorkflows: action.workflows,
      };
    case actions.RETRIEVED_INFERENCE_WORKFLOWS:
      return {
        ...state,
        inferenceWorkflows: action.workflows,
      };
    case actions.RETRIEVED_SUPPORTING_CONTENT_WORKFLOWS:
      return {
        ...state,
        supportingContentWorkflows: action.workflows,
      };
    case actions.RETRIEVED_WORKFLOW:
      return {
        ...state,
        workflow: action.workflow,
      };
    case actions.RETRIEVED_NODES:
      return {
        ...state,
        nodes: action.nodes,
      };
    case actions.RETRIEVED_NODE:
      console.log("RETRIEVED NODE:", action);
      return {
        ...state,
        node: action.node,
      };
    case actions.RETRIEVED_FUNCTIONS:
      return {
        ...state,
        functions: action.functions,
      };
    case actions.RETRIEVED_FUNCTION:
      return {
        ...state,
        funct: action.funct,
      };
    case actions.WORKFLOW_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actions.SAVING_WORKFLOW:
      return {
        ...state,
        savingWorkflow: action.saving,
      };
    case actions.SAVING_NODE:
      return {
        ...state,
        savingNode: action.saving,
      };
    case actions.SAVED_NODE:
      console.log("ACTIONS SAVED NODE: ", action.savedNode);
      return {
        ...state,
        node: action.savedNode,
      };
    case actions.SAVING_FUNCTION:
      return {
        ...state,
        savingFunction: action.saving,
      };
    case actions.CLEAR_SAVED_WORKFLOW:
      return {
        ...state,
        workflow: null,
      };
    case actions.CLEAR_SAVED_NODE:
      return {
        ...state,
        node: null,
      };
    case actions.CLEAR_SAVED_FUNCTION:
      return {
        ...state,
        funct: null,
      };
    case actions.RUNNING_NODE:
      return {
        ...state,
        runningNode: action.running,
      };
    case actions.RUN_NODE_RESULTS:
      return {
        ...state,
        nodeResults: action.results,
      };
    case actions.RUNNING_WORKFLOW:
      return {
        ...state,
        runningWorkflow: action.running,
      };
    case actions.RUN_WORKFLOW_RESULTS:
      return {
        ...state,
        workflowResults: action.results,
      };
    case actions.ADD_FUNCTION_TO_NODE:
      return {
        ...state,
        functionToAdd: action.functionToAdd,
      };

    default:
      return state;
  }
};

export default workflows;
